import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import CombinedImage from '../CombinedImage/CombinedImage';

const bem = new BEMHelper('ImageWithChild');

const ImageWithChild = (props) => {
    const { children, className, src, ...rest } = props;
    const { image, wrapper = className } = className || {};

    return (
        <div className={bem(null, null, wrapper)}>
            {src && <CombinedImage className={image} src={src} {...rest} />}
            {children && <div className={bem('child')}>{children}</div>}
        </div>
    );
};

ImageWithChild.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    src: PropTypes.string,
};

export default ImageWithChild;
